/**
 * Notification Provider Component
 * Wraps the app to provide global snackbar notifications
 */

import React, {useState, useEffect} from 'react';
import {Snackbar, useTheme} from 'react-native-paper';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {
  notificationService,
  NotificationState,
} from '../services/notificationService';

export const NotificationProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const theme = useTheme();
  const insets = useSafeAreaInsets();
  const [state, setState] = useState<NotificationState>({
    visible: false,
    message: '',
    type: 'info',
    duration: 3000,
  });

  useEffect(() => {
    // Subscribe to notification service
    const unsubscribe = notificationService.subscribe(newState => {
      setState(newState);
    });

    return unsubscribe;
  }, []);

  const getBackgroundColor = () => {
    switch (state.type) {
      case 'success':
        return '#4CAF50';
      case 'error':
        return '#F44336';
      case 'warning':
        return '#FF9800';
      case 'info':
      default:
        return theme.colors.primary;
    }
  };

  const handleDismiss = () => {
    notificationService.hide();
  };

  return (
    <>
      {children}
      <Snackbar
        visible={state.visible}
        onDismiss={handleDismiss}
        duration={state.duration}
        wrapperStyle={{
          top: 0,
          bottom: 'auto',
          marginTop: insets.top + 56 + 20,
        }}
        style={{backgroundColor: getBackgroundColor()}}
        action={state.action}
        theme={{
          colors: {
            onSurface: '#FFFFFF',
            inverseOnSurface: '#FFFFFF',
          },
        }}>
        {state.message}
      </Snackbar>
    </>
  );
};

